import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { PartnerLicenceListType } from "./Types";
import { updatePartnerLicenceListPayloadType } from "../../../saga/partner-program/licence-management/saga-actions";

type initialStateType = {
    fetchedPartnerLicenceID: number;
    partnerLicenceList: PartnerLicenceListType;
    status: {
        partnerLicenceListLoading: boolean;
        addPartnerLicenceStatus: boolean;
        addPartnerLicenceMessage: string;
        addPartnerLicenceLoading: boolean;
        updatePartnerLicenceStatus: boolean;
        updatePartnerLicenceMessage: string;
        updatePartnerLicenceLoading: boolean;
        deletePartnerLicenceStatus: boolean;
        deletePartnerLicenceMessage: string;
        deletePartnerLicenceLoading: boolean;
    }
}
var initialState: initialStateType = {
    fetchedPartnerLicenceID: 0,
    partnerLicenceList: [],
    status: {
        partnerLicenceListLoading: false,
        addPartnerLicenceStatus: false,
        addPartnerLicenceMessage: "",
        addPartnerLicenceLoading: false,
        updatePartnerLicenceStatus: false,
        updatePartnerLicenceMessage: "",
        updatePartnerLicenceLoading: false,
        deletePartnerLicenceStatus: false,
        deletePartnerLicenceMessage: "",
        deletePartnerLicenceLoading: false,
    }
}

const partnerLicenceSlice = createSlice({
    name: "partner_licenceProgram",
    initialState: initialState,
    reducers: {
        setFetchedPartnerLicenceID: (state, action) => {
            state.fetchedPartnerLicenceID = action.payload;
        },
        setPartnerLicenceListLoading: (state, action) => {
            state.status.partnerLicenceListLoading = action.payload;
        },
        setPartnerLicenceList: (state, action:PayloadAction<PartnerLicenceListType>) => {
            state.partnerLicenceList = action.payload;
        },
        setAddPartnerLicenceStatus: (state, action) => {
            state.status.addPartnerLicenceStatus = action.payload;
        },
        setAddPartnerLicenceMessage: (state, action) => {
            state.status.addPartnerLicenceMessage = action.payload;
        },
        setAddPartnerLicenceLoading : (state, action) => {
            state.status.addPartnerLicenceLoading = action.payload;
        },
        setUpdatePartnerLicenceStatus: (state, action) => {
            state.status.updatePartnerLicenceStatus = action.payload;
        },
        setUpdatePartnerLicenceMessage: (state, action) => {
            state.status.updatePartnerLicenceMessage = action.payload;
        },
        setUpdatePartnerLicenceLoading: (state, action) => {
            state.status.updatePartnerLicenceLoading = action.payload;
        },
         setPartnerLicenceListUpdate: (
              state,
              action: PayloadAction<updatePartnerLicenceListPayloadType>
            ) => {
              const updated = action.payload;
              const idx = state.partnerLicenceList.findIndex((t) => t.ID === updated.ID);
              if (idx !== -1) {
                state.partnerLicenceList[idx] = {
                  ...state.partnerLicenceList[idx],
                  license_type: updated.license_type,
                  points: Number(updated.points),
                  license_count: Number(updated.license_count),
                  comments: updated.comments,
                };
              }
            },
        setDeletePartnerLicenceStatus: (state, action) => {
            state.status.deletePartnerLicenceStatus = action.payload;
        },
        setDeletePartnerLicenceMessage: (state, action) => {
            state.status.deletePartnerLicenceMessage = action.payload;
        },
        setDeletePartnerLicenceLoading: (state, action) => {
            state.status.deletePartnerLicenceLoading = action.payload;
        },
    }
})

export const partnerLicenceSliceReducer = partnerLicenceSlice.reducer;
export const partnerLicenceSliceAction = partnerLicenceSlice.actions;